export const PROCEDURES = [
    {
        key: 'arterial_line',
        label: 'Arterial line',
        variantLabel: 'Site',
        variants: ['Radial', 'Femoral', 'Axillary', 'Brachial'],
        sideApplicable: true,
        usGuidanceApplicable: true,
        suggestedHillos: [5, 6],
        synonyms: ['art line', 'a-line', 'aline', 'arterial cannula', 'arterial cannulation'],
    },
    {
        key: 'ascitic_aspiration',
        label: 'Ascitic aspiration',
        usGuidanceApplicable: true,
        suggestedHillos: [6],
        synonyms: ['ascitic tap', 'paracentesis', 'abdominal paracentesis', 'abdominal tap'],
    },
    {
        key: 'ascitic_drain',
        label: 'Ascitic drain',
        usGuidanceApplicable: true,
        suggestedHillos: [6],
        synonyms: ['abdominal drain', 'peritoneal drain'],
    },
    {
        key: 'brainstem_death_testing',
        label: 'Brainstem death testing',
        suggestedHillos: [8],
        synonyms: [
            'brain stem death',
            'brain stem death testing',
            'bsd',
            'death by neurological criteria',
        ],
    },
    {
        key: 'bronchoscopy',
        label: 'Bronchoscopy',
        suggestedHillos: [6],
        synonyms: ['bronch', 'bal', 'bronchoalveolar lavage'],
    },
    {
        key: 'central_venous_catheter',
        label: 'Central venous catheter',
        variantLabel: 'Site',
        variants: ['Internal jugular', 'Femoral', 'Subclavian', 'Axillary'],
        sideApplicable: true,
        usGuidanceApplicable: true,
        suggestedHillos: [5, 6],
        synonyms: [
            'cvc',
            'central line',
            'ij line',
            'central venous line',
            'central venous access',
            'central venous cannulation',
            'triple lumen',
        ],
    },
    {
        key: 'chest_drain_seldinger',
        label: 'Chest drain (Seldinger)',
        sideApplicable: true,
        usGuidanceApplicable: true,
        suggestedHillos: [5, 6],
        synonyms: ['icd', 'intercostal drain', 'seldinger drain', 'pigtail'],
    },
    {
        key: 'chest_drain_surgical',
        label: 'Chest drain (surgical)',
        sideApplicable: true,
        suggestedHillos: [5, 6],
        synonyms: ['surgical drain', 'blunt dissection drain', 'large bore chest drain'],
    },
    {
        key: 'cricothyroidotomy',
        label: 'Cricothyroidotomy',
        suggestedHillos: [5, 10],
        synonyms: ['crico', 'front of neck access', 'fona', 'emergency airway'],
    },
    {
        key: 'dc_cardioversion',
        label: 'DC cardioversion',
        suggestedHillos: [5, 6],
        synonyms: ['dccv', 'cardioversion', 'defibrillation'],
    },
    {
        key: 'ecmo_cannulation',
        label: 'ECMO cannulation',
        variantLabel: 'Site',
        variants: ['Femoral', 'Jugular', 'Axillary'],
        sideApplicable: true,
        usGuidanceApplicable: true,
        suggestedHillos: [6, 14],
        synonyms: ['ecmo', 'ecls', 'extracorporeal'],
    },
    {
        key: 'fibreoptic_intubation',
        label: 'Fibreoptic intubation',
        suggestedHillos: [10],
        synonyms: [
            'awake fibreoptic',
            'afoi',
            'fibreoptic intubation awake',
            'fibreoptic intubation asleep',
            'flexible bronchoscopic intubation',
        ],
    },
    {
        key: 'intraosseous_access',
        label: 'Intraosseous access',
        sideApplicable: true,
        suggestedHillos: [5, 13],
        synonyms: ['io', 'ez-io', 'intraosseous needle'],
    },
    {
        key: 'intubation',
        label: 'Intubation',
        variantLabel: 'Technique',
        variants: ['Direct laryngoscopy', 'Videolaryngoscopy'],
        suggestedHillos: [5, 10],
        synonyms: [
            'ett',
            'rsi',
            'rapid sequence induction',
            'nasal intubation',
            'double lumen tube',
            'dlt',
            'tracheal intubation',
            'endotracheal tube',
            'airway',
        ],
    },
    {
        key: 'lumbar_puncture',
        label: 'Lumbar puncture',
        usGuidanceApplicable: true,
        suggestedHillos: [6, 12],
        synonyms: ['lp', 'spinal tap', 'csf sampling'],
    },
    {
        key: 'lung_ultrasound',
        label: 'Lung ultrasound',
        sideApplicable: true,
        suggestedHillos: [6],
        synonyms: ['fusic lung', 'lus', 'pleural ultrasound', 'thoracic ultrasound'],
    },
    {
        key: 'nasogastric_tube',
        label: 'Nasogastric tube insertion',
        suggestedHillos: [6],
        synonyms: ['ng', 'ng tube', 'ryles tube'],
    },
    {
        key: 'nasojejunal_tube',
        label: 'Nasojejunal tube insertion',
        suggestedHillos: [6],
        synonyms: ['nj', 'nj tube', 'post-pyloric feeding tube'],
    },
    {
        key: 'oesophageal_doppler',
        label: 'Oesophageal Doppler',
        suggestedHillos: [6],
        synonyms: ['odm', 'oesophageal doppler monitor', 'doppler cardiac output'],
    },
    {
        key: 'pa_catheter',
        label: 'Pulmonary artery catheter',
        sideApplicable: true,
        usGuidanceApplicable: true,
        suggestedHillos: [6, 14],
        synonyms: ['pac', 'pac insertion', 'swan', 'swan-ganz', 'pulmonary artery flotation catheter'],
    },
    {
        key: 'pericardiocentesis',
        label: 'Pericardiocentesis',
        usGuidanceApplicable: true,
        suggestedHillos: [6, 14],
        synonyms: ['pericardial drain', 'pericardial tap'],
    },
    {
        key: 'picc',
        label: 'Peripherally inserted central catheter (PICC)',
        sideApplicable: true,
        usGuidanceApplicable: true,
        suggestedHillos: [6],
        synonyms: ['picc', 'picc line', 'long line'],
    },
    {
        key: 'picco_line',
        label: 'PiCCO line',
        variantLabel: 'Site',
        variants: ['Femoral', 'Brachial', 'Axillary'],
        sideApplicable: true,
        usGuidanceApplicable: true,
        suggestedHillos: [6],
        synonyms: ['picco', 'thermodilution catheter', 'cardiac output monitoring'],
    },
    {
        key: 'pleural_aspiration',
        label: 'Pleural aspiration',
        sideApplicable: true,
        usGuidanceApplicable: true,
        suggestedHillos: [5, 6],
        synonyms: ['pleural tap', 'pleural tap and aspiration', 'thoracocentesis', 'thoracentesis'],
    },
    {
        key: 'prone_positioning',
        label: 'Prone positioning',
        suggestedHillos: [6],
        synonyms: ['proning', 'prone ventilation', 'prone'],
    },
    {
        key: 'reboa',
        label: 'REBOA',
        sideApplicable: true,
        usGuidanceApplicable: true,
        suggestedHillos: [5, 6],
        synonyms: [
            'resuscitative endovascular balloon occlusion of the aorta',
            'aortic balloon occlusion',
        ],
    },
    {
        key: 'sengstaken_tube',
        label: 'Sengstaken tube insertion',
        suggestedHillos: [5, 6],
        synonyms: [
            'sengstaken',
            'sengstaken insertion',
            'sengstaken blakemore',
            'minnesota tube',
            'balloon tamponade',
        ],
    },
    {
        key: 'tracheostomy',
        label: 'Tracheostomy',
        variantLabel: 'Technique',
        variants: ['Percutaneous', 'Surgical'],
        usGuidanceApplicable: true,
        suggestedHillos: [6, 10],
        synonyms: ['trache', 'trachy', 'percutaneous tracheostomy', 'pdt'],
    },
    {
        key: 'transcranial_doppler',
        label: 'Transcranial Doppler',
        sideApplicable: true,
        suggestedHillos: [6, 12],
        synonyms: ['tcd', 'transcranial ultrasound'],
    },
    {
        key: 'transcutaneous_pacing',
        label: 'Transcutaneous pacing',
        suggestedHillos: [5, 6],
        synonyms: ['external pacing', 'tc pacing', 'pacing'],
    },
    {
        key: 'transfer_intra_hospital',
        label: 'Transfer (intra-hospital)',
        suggestedHillos: [5],
        synonyms: ['intra hospital', 'internal transfer', 'transfer to ct', 'transfer to theatre'],
    },
    {
        key: 'transfer_inter_hospital',
        label: 'Transfer (inter-hospital)',
        suggestedHillos: [5],
        synonyms: [
            'inter hospital',
            'extra hospital',
            'retrieval',
            'external transfer',
            'blue light transfer',
        ],
    },
    {
        key: 'transoesophageal_echo',
        label: 'Transoesophageal echocardiography',
        suggestedHillos: [6, 14],
        synonyms: ['toe', 'tee', 'transesophageal echo'],
    },
    {
        key: 'transthoracic_echo',
        label: 'Transthoracic echocardiography',
        suggestedHillos: [6, 14],
        synonyms: ['tte', 'echo', 'echocardiogram', 'fice', 'fusic heart', 'focused echo'],
    },
    {
        key: 'ultrasound_abdomen',
        label: 'Ultrasound abdomen',
        suggestedHillos: [6],
        synonyms: [
            'abdominal ultrasound',
            'fast',
            'fast scan',
            'aaa',
            'renal ultrasound',
            'hepatobiliary ultrasound',
            'bladder scan',
        ],
    },
    {
        key: 'ultrasound_dvt',
        label: 'Ultrasound DVT',
        sideApplicable: true,
        suggestedHillos: [6],
        synonyms: ['dvt', 'dvt scan', 'doppler legs', 'compression ultrasound'],
    },
    {
        key: 'vascath',
        label: 'Vascath insertion',
        variantLabel: 'Site',
        variants: ['Internal jugular', 'Femoral', 'Subclavian'],
        sideApplicable: true,
        usGuidanceApplicable: true,
        suggestedHillos: [6],
        synonyms: ['vascath', 'dialysis catheter', 'niagara', 'rrt line', 'haemofiltration line'],
    },
];
const BY_KEY = new Map(PROCEDURES.map((procedure) => [procedure.key, procedure]));
export function procedureByKey(key) {
    return BY_KEY.get(key);
}
export function procedureLabel(key) {
    return BY_KEY.get(key)?.label ?? key;
}
/** Alphabetical by label, which is the order the picker shows when not searching. */
export const PROCEDURES_ALPHABETICAL = [...PROCEDURES].sort((a, b) => a.label.localeCompare(b.label, 'en-GB'));
/**
 * Case- and accent-insensitive. "Doppler" should match a search for "doppler",
 * and someone typing on a phone keyboard should not be defeated by an accent.
 */
function normalise(value) {
    return value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}
/**
 * Searches labels and synonyms.
 *
 * Ranking, best first: whole label starts with the query, then a word within
 * the label starts with it, then a synonym starts with it, then anything
 * containing it. That ordering is what makes "art" land on Arterial line rather
 * than on the four other procedures whose descriptions happen to contain it.
 *
 * An empty query returns the alphabetical list, which is what the picker shows
 * before anyone types.
 */
export function searchProcedures(query) {
    const needle = normalise(query);
    if (needle === '')
        return PROCEDURES_ALPHABETICAL;
    const scored = [];
    for (const procedure of PROCEDURES) {
        const label = normalise(procedure.label);
        const synonyms = (procedure.synonyms ?? []).map(normalise);
        let score = -1;
        if (label.startsWith(needle)) {
            score = 0;
        }
        else if (label.split(/[\s(]+/).some((word) => word.startsWith(needle))) {
            score = 1;
        }
        else if (synonyms.some((synonym) => synonym.startsWith(needle))) {
            score = 2;
        }
        else if (synonyms.some((synonym) => synonym.includes(needle))) {
            score = 3;
        }
        else if (label.includes(needle)) {
            score = 4;
        }
        if (score >= 0)
            scored.push({ procedure, score });
    }
    return scored
        .sort((a, b) => a.score - b.score || a.procedure.label.localeCompare(b.procedure.label, 'en-GB'))
        .map((entry) => entry.procedure);
}
//# sourceMappingURL=procedures.js.map